import React, { useState, forwardRef, useEffect, useRef } from "react";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CloseIcon from "@mui/icons-material/Close";
import AxiosWrapper, { axiosGetWithTokenHeader } from "../base/AxiosWrapper";
import { getPresignedUrlForFiles } from "../../Ticketing_Tool/model/generalApiCalls";
import axios from "axios";
import { CircularProgress } from "@mui/material";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CCarousel = ({ cOpen, cCloseClicked, cHeader, cImages, cStatus, cEntity }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [fileUrl, setFileUrl] = useState(null)
  const [loading, setLoading] = useState(false);

  let presignedUrlsList = useRef([]);

  useEffect(() => {
    let active = true;

    // Helper function to fetch a URL for a specific index
    const fetchUrlForIndex = async (index) => {
      // If it's already cached and hasn't expired, return it immediately
      const cachedData = presignedUrlsList.current[index];
      if (cachedData && (!cachedData.expires || cachedData.expires > Date.now())) {
        return cachedData.src; 
      }

      // Otherwise, make the API call
      try {
        let responseData;
        if (cStatus !== "Resolved") {
          let newfileId = new FormData();
          newfileId.append("id", cImages[index].id);
          newfileId.append("entity", cEntity);
          const response = await getPresignedUrlForFiles(newfileId);
          responseData = response.data;
        } else {
          // Reverted back to your original process.env call
          const response = await axios.get(
            `${process.env.REACT_APP_TICKETING_TOOL_BACKEND_URL}/getBlobStream?id=${cImages[index].id}&entity=${cEntity}`
          );
          responseData = response.data;
        }

        // Cache the response
        presignedUrlsList.current[index] = responseData;
        return responseData.src;
      } catch (error) {
        console.error("Failed to fetch media URL", error);
        return null;
      }
    };

    const loadCurrentAndPrefetchNext = async () => {
      // 1. Only show loading spinner if we don't have the current image cached
      if (!presignedUrlsList.current[selectedImageIndex]) {
        setLoading(true);
      }

      // 2. Fetch the current URL
      const currentUrl = await fetchUrlForIndex(selectedImageIndex);
      
      if (active && currentUrl) {
        setFileUrl(currentUrl);
      }

      // 3. SILENT PREFETCH: Fetch the NEXT image's URL in the background
      const nextIndex = selectedImageIndex + 1;
      if (nextIndex < cImages.length) {
        fetchUrlForIndex(nextIndex); // Happens silently without awaiting
      }
    };

    loadCurrentAndPrefetchNext();

    return () => {
      active = false;
    };
  }, [selectedImageIndex, cImages, cStatus, cEntity]); 

  // Function to navigate to the previous image
  const handlePreviousImage = () => {
    if (selectedImageIndex > 0) {
      setSelectedImageIndex(selectedImageIndex - 1);
    }
  };

  // Function to navigate to the next image
  const handleNextImage = () => {
    if (selectedImageIndex < cImages.length - 1) {
      setSelectedImageIndex(selectedImageIndex + 1);
    }
  };

  return (
    <Dialog
      open={cOpen}
      TransitionComponent={Transition}
      fullScreen={true}
      sx={{ margin: "6em" }}>
      <DialogTitle
        sx={{
          textAlign: "center",
          color: (theme) => theme.palette.primary.main,
          fontWeight: "bold",
        }}>
        {selectedImageIndex + 1} of {cImages.length}
        <IconButton
          onClick={cCloseClicked}
          sx={{
            position: "absolute",
            right: "1.5em",
            top: "1em",
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          maxWidth: "90em",
          height: "90em",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <IconButton
          onClick={handlePreviousImage}
          sx={{
            position: "absolute",
            top: "50%",
            left: 0,
            transform: "translateY(-50%)",
            zIndex: 1,
          }}>
          <ArrowBackIosIcon />
        </IconButton>
        
        {loading && <CircularProgress size={60} />}
        
        {cImages.length > 0 && fileUrl && (
          cImages[selectedImageIndex].type.startsWith("image/") ?
            <img
              src={fileUrl}
              alt={`Image ${selectedImageIndex + 1}`}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                display: loading ? "none" : "block" // Hides image while loading to prevent broken image icon
              }}
              onLoad={() => setLoading(false)}
            /> :
            <video 
              src={fileUrl} 
              controls 
              alt={`Video ${selectedImageIndex + 1}`} 
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                display: loading ? "none" : "block"
              }}
              onLoadedData={() => setLoading(false)}
            />
        )}
        
        <IconButton
          onClick={handleNextImage}
          sx={{
            position: "absolute",
            top: "50%",
            right: 0,
            transform: "translateY(-50%)",
            zIndex: 1,
          }}>
          <ArrowForwardIosIcon />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
};

export default CCarousel;